<template>
	<div class="no-content">
		<h3>{{header}}</h3>
		<p v-if="icon" v-html="paragraph"></p>
		<p v-else>{{paragraph}}</p>
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "no-content",
	props: {
		header: {
			type: String,
			required: true
		},
		paragraph: {
			type: String,
			required: false
		},
		icon: {
			type: Boolean,
			required: false
		}
	}
};
</script>

<style scoped>
.no-content {
	position: relative;
	background-color: inherit;
	height: auto;
	padding: 20px;
	margin: 20px auto;
	border-radius: 20px;
	color: #ccc;
	margin: 0;
	text-align: center;
}

.no-content h3 {
	font-size: 17px;
	color: #fff;
	line-height: 1.3;
	margin-bottom: 5px;
}

.no-content p {
	font-size: 11px;
	line-height: 1.3;
}

.no-content ion-icon {
	font-size: 18px;
	vertical-align: middle;
}

@media only screen and (max-width: 768px) {
	.no-content h3 {
		font-size: 15px;
	}

	.no-content p {
		font-size: 10px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/errors/NoContent.vue